// modules/team/teamCarBanner.js
const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;

if (ScrollTrigger) {
    try {
        gsap.registerPlugin(ScrollTrigger);
    } catch (e) {}
}

export default function initTeamCarBanner(){
    const root = document.querySelector(".team-car-banner");
    if (!root) return () => {};

    const prefersReduced = (
        document.documentElement.dataset.ignorePrm === '1'
    ) ? false : window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const frame = root.querySelector(".car-frame");
    const logo  = root.querySelector(".car-logo");
    const img   = root.querySelector(".car-img");
    const cta   = root.querySelector(".car-cta"); // нове

    const triggers = [], tweens = [];
    const track = t => { if (t?.vars?.scrollTrigger) triggers.push(t.vars.scrollTrigger); tweens.push(t); return t; };

    // початкові стани
    if (img)  gsap.set(img,  { autoAlpha:0, scale:1.04, willChange:"transform,opacity" });
    if (logo) gsap.set(logo, { autoAlpha:0, y:-12, willChange:"transform,opacity" });
    if (cta)  gsap.set(cta,  { autoAlpha:0, y:10, willChange:"transform,opacity" });

    if (!prefersReduced && frame && img){
        // reveal кадру
        track(gsap.fromTo(img, { autoAlpha:0, scale:1.04 }, {
            autoAlpha:1, scale:1, duration:.8, ease:"power2.out",
            scrollTrigger:{ trigger:frame, start:"top 88%", toggleActions:"play none none none" },
            onComplete:()=>gsap.set(img,{ clearProps:"opacity,visibility,scale,willChange" })
        }));
        // паралакс
        const amp = Math.min(18, Math.max(8, Math.round(window.innerHeight/80)));
        track(gsap.to(img,{
            y:amp, ease:"none", force3D:true,
            scrollTrigger:{ trigger:frame, start:"top bottom", end:"bottom top", scrub:.4, invalidateOnRefresh:true }
        }));
    } else if (img){ gsap.set(img,{ autoAlpha:1, scale:1 }); }

    if (!prefersReduced && frame && logo){
        track(gsap.to(logo,{
            autoAlpha:1, y:0, duration:.55, ease:"power2.out",
            scrollTrigger:{ trigger:frame, start:"top 82%", toggleActions:"play none none none" },
            onComplete:()=>gsap.set(logo,{ clearProps:"opacity,visibility,transform,willChange" })
        }));
    } else if (logo){ gsap.set(logo,{ autoAlpha:1, y:0 }); }

    // CTA reveal — трохи пізніше за лого
    if (!prefersReduced && frame && cta){
        track(gsap.to(cta,{
            autoAlpha:1, y:0, duration:.6, ease:"power2.out", delay:.05,
            scrollTrigger:{ trigger:frame, start:"top 78%", toggleActions:"play none none none" },
            onComplete:()=>gsap.set(cta,{ clearProps:"opacity,visibility,transform,willChange" })
        }));
    } else if (cta){ gsap.set(cta,{ autoAlpha:1, y:0 }); }

    // refresh guard
    ScrollTrigger.addEventListener("refresh", ()=>{
        if (!frame) return;
        const top = frame.getBoundingClientRect().top;
        if (top < innerHeight * 0.88){
            if (img)  gsap.set(img,{ autoAlpha:1, scale:1 });
            if (logo) gsap.set(logo,{ autoAlpha:1, y:0 });
            if (cta)  gsap.set(cta,{ autoAlpha:1, y:0 });
        }
    });

    // bfcache back
    window.addEventListener("pageshow", (e)=>{
        if (e.persisted){
            if (img)  gsap.set(img,{ autoAlpha:1, scale:1 });
            if (logo) gsap.set(logo,{ autoAlpha:1, y:0 });
            if (cta)  gsap.set(cta,{ autoAlpha:1, y:0 });
            ScrollTrigger.refresh();
        }
    });

    return ()=>{ triggers.forEach(t=>t?.kill()); tweens.forEach(t=>t?.kill()); };
}
